import React from 'react';
import { formatNumber, formatTransactionValue } from '../../../../../shared/utils/numberFormatter';

const TransactionMetricsCards = ({ metrics, isLoading }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  // Card component - matching User Journey style
  const StatCard = ({ title, value, isLoading = false }) => (
    <div className="p-4 md:p-6 text-center" style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}>
      <div className="text-xs font-medium mb-2" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
        {title}
      </div>
      {isLoading ? (
        <div className="h-8 mb-1 animate-pulse" style={{ backgroundColor: styles.secondaryBg }}></div>
      ) : (
        <div className="text-lg md:text-xl font-semibold mb-1" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
          {value}
        </div>
      )}
    </div>
  );

  const cards = [
    {
      title: 'Transacted Wallets',
      value: metrics?.transactedWallets ? formatNumber(metrics.transactedWallets, 1) : '0',
      loading: isLoading
    },
    {
      title: 'Transaction Count',
      value: metrics?.transactionCount ? formatNumber(metrics.transactionCount, 1) : '0',
      loading: isLoading
    },
    {
      title: 'Transaction Value',
      value: metrics?.transactionValue ? formatTransactionValue(metrics.transactionValue) : '0',
      loading: isLoading
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {cards.map((card, index) => (
        <StatCard key={index} title={card.title} value={card.value} isLoading={card.loading} />
      ))}
    </div>
  );
};

export default TransactionMetricsCards;

